<script setup>
import ImportModelDialog from "../importModelDialog.vue";

</script>

<template>
<div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      :disabled="disableInput"
      @click="addVin"
    >添加</el-button>
    <el-button
      type="primary"
      plain
      icon="el-icon-upload2"
      size="mini"
      @click="vinImportTable"
      :disabled="disableInput"
    >批量导入</el-button>
    <el-table
      :data="vinDatas"
      style="width: 100%"
      ref="tableRef"
      stripe
      border
    >
      <el-table-column
        prop="vin"
        label="VIN"
        width="180">
        <template slot-scope="scope">
          <div v-if="disableInput">
            {{ scope.row.vin}}
          </div>
          <div v-else>
            <el-input  @change="value=>onInputChange(value, scope.row)" v-model="scope.row.vin" placeholder="请输入VIN"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderNum"
        label="生产订单号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="info"
        label="信息"
        width="180">
      </el-table-column>
      <el-table-column
        prop="manufactureDate"
        label="生产日期">
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="deleteVin(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
    <import-model-dialog  ref="importModelDialog"
                          :uploadUrl="vinUploadUrl"
                          templateUrl="https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/09/4f8077bb596e4a4cb3fa3f2ba02b4a59.xlsx"
                          @success="getList" />
  </div>
</div>
</template>

<style scoped lang="scss">
  ::v-deep .el-table {
    margin: 10px 0;
  }
</style>
<script>
import {getVinDetail} from "../../api/api";
import {uploadUrl} from "../../util/url";

export default {
  name: 'vinInput',
  props: {
    disableInput: {
      type: Boolean,
      default: false
    },
    receivedList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      vinUploadUrl: uploadUrl + "/manage/car/feedback/question/importVin", // 导入地址
      vinDatas: []
    }
  },
  methods: {
    getList(data) {
      if (data.length > 0) {
       let newData = [];
       let timstramp =  Date.now()
       for (let i = 0; i < data.length; i++) {
         let item = data[i];
         let newItem = {
           vin: item.vin,
           info: item.messageZh,
           orderNum: item.info,
           rowItemId: timstramp + "" + "_" +i
         }
         newData.push(newItem)
       }
        this.vinDatas = [...this.vinDatas, ...newData];
        this.updatePropList();
      }
    },
    onInputChange(value,row){
      let data = {
        data: {
          vinCheckRespList:[
            {
              vin:value
            }
          ]
        }
      }
      getVinDetail(data).then(res => {
        if(res.data.status == "0") {
          let item = res.data[0];
          if (item) {
            row.info = item.messageZh;
            row.orderNum = res.data.data.info;
          }
          this.updatePropList();
        }
      })
    },
    updatePropList(){
      this.$emit('update:receivedList',this.vinDatas)
    },
    addVin(){
      let timstramp =  Date.now();
      this.vinDatas.push({rowItemId:timstramp})
      this.updatePropList();
    },
    vinImportTable(){
      this.$refs.importModelDialog.init("导入VIN");
    },
    deleteVin(row){
      let index = this.vinDatas.findIndex(item=>item.rowItemId === row.rowItemId)
      if(index !== -1){
        this.vinDatas.splice(index,1)
      }
      this.updatePropList();
    },
  }
  ,mounted() {
    this.vinDatas = this.receivedList;
  }
}
</script>
